import React from 'react';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';

export default function OptyIconButton({ icon, onClick, disabled, tooltip }) {
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton style={{width:24, height:24}} onClick={onClick} disabled={disabled}>
          <Icon>{icon}</Icon>
        </IconButton>
      </span>
    </Tooltip>
  );
}


// WEBPACK FOOTER //
// ./src/OptyIconButton.js